// RITA-1525 — Abfragedokument: Vertragsarten mit Logo für den Vertragseditor (Kopfzeile zeigt das
// Logo der gewählten Vertragsart, Entscheidung Julia 28.09.2026 nach RITA-1526). Hook dazu:
// hooks/useVertragsartenMitLogo.ts.
//
// Eigenes Dokument statt der App-Start-Abfrage der Vertragsarten: `logo_data_url` lädt das Backend
// nur, wenn eine Abfrage das Feld auswählt (bis 1 MB je Vertragsart). Die Einstellungsseite hat ihr
// eigenes Dokument (features/options/api/contractTypeLogo.ts); Apollo führt beide über die id im
// Cache zusammen.
import { gql } from '@apollo/client';

export interface VertragsartMitLogo {
  id: number;
  titel: string;
  /** data:-URL des Logos oder null, wenn die Vertragsart keins hat. */
  logoDataUrl: string | null;
}

export interface VertragsartenStand {
  /** Zuletzt geladener Stand; leer, solange noch nie erfolgreich geladen wurde. */
  vertragsarten: VertragsartMitLogo[];
  /** Ein Abruf läuft (erste Ladung oder Auffrischen, auch wenn der Cache schon einen Stand liefert). */
  laedt: boolean;
  /** Der letzte Abruf ist gescheitert (auch wenn `vertragsarten` noch den früheren Stand zeigt). */
  fehler: boolean;
}

/** Rohantwort des Backends (ContractType-Felder). */
export interface VertragsartenAntwort {
  getAllContractTypes: { id: number | string; title: string; logo_data_url?: string | null }[] | null;
}

export const GET_VERTRAGSARTEN_MIT_LOGO = gql`
  query getVertragsartenMitLogo {
    getAllContractTypes {
      id
      title
      logo_data_url
    }
  }
`;
